import React, {useMemo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import Button from "components/inputs/button"
import memo from "set-state-compare/build/memo"
import Routes from "shared/routes"
import {Survey} from "models"
import SurveysTable from "components/surveys/table"
import {useAdminLayout} from "components/admin/layout"
import useCanCan from "@kaspernj/api-maker/build/use-can-can"
import useI18n from "i18n-on-steroids/build/src/use-i18n.js"
import {View} from "react-native"

export default memo(shapeComponent(class RoutesAdminSurveysIndex extends ShapeComponent {
  setup() {
    const adminLayout = useAdminLayout()
    const {t} = useI18n({namespace: "js.routes.admin.surveys.index"})

    const canCan = useCanCan(() => [[Survey, ["create"]]])

    this.setInstance({canCan, t})

    useMemo(() => {
      adminLayout?.setState({
        actions: this.actions(),
        active: "surveys",
        headerTitle: Survey.modelName().human({count: 2})
      })
    }, [adminLayout, canCan.getCacheKey()])
  }

  render() {
    return (
      <View dataSet={{route: "admin--surveys--index"}}>
        <SurveysTable adminLayout />
      </View>
    )
  }

  actions() {
    const {canCan, t} = this.tt

    return (
      <>
        {canCan.can("create", Survey) &&
          <Button className="new-survey-button" icon="plus" label={t(".add_new_survey")} to={Routes.newAdminSurveyPath()} />
        }
      </>
    )
  }
}))
